import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { renderRich } from "../../lib/richText";
import { CapIcon } from "./CapIcon";
import { ResourceList } from "./ResourceList";

const Sub = ({ s, i }) => {
  const [open, setOpen] = useState(i === 0);
  return (
    <div className="rounded-2xl ring-1 ring-black/5 bg-[#F7F8FB] overflow-hidden" data-testid={`cap-sub-${i}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-3 px-4 py-3 text-left">
        <span className="text-[11px] font-extrabold text-[#B99B2E] tracking-widest">{String(i + 1).padStart(2, "0")}</span>
        <span className="flex-1 font-bold text-[#0A1C30] text-sm">{s.titulo}</span>
        <ChevronDown className={`w-4 h-4 text-[#6B7688] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 pb-4">
          {s.texto && <div className="blog-rich text-sm text-[#2A3446]" dangerouslySetInnerHTML={{ __html: renderRich(s.texto) }} />}
          <ResourceList recursos={s.recursos} testid={`cap-sub-${i}-res`} />
        </div>
      )}
    </div>
  );
};

export const ModuleReader = ({ cap }) => (
  <div data-testid="cap-module-reader">
    <div className="flex items-start gap-4">
      <span className="w-14 h-14 rounded-2xl bg-[#0A1C30] flex items-center justify-center shrink-0">
        <CapIcon name={cap.icono} className="w-7 h-7 text-[var(--gold)]" />
      </span>
      <div>
        <div className="text-[11px] font-extrabold tracking-[0.25em] text-[#B99B2E]">MÓDULO {String(cap.orden || 0).padStart(2, "0")}</div>
        <h2 className="text-2xl sm:text-3xl font-extrabold text-[#0A1C30] leading-tight" data-testid="cap-module-title">{cap.titulo}</h2>
        {cap.resumen && <p className="mt-1 text-[#4A5568] font-serif-it">{cap.resumen}</p>}
      </div>
    </div>
    {cap.contenido && <div className="blog-rich mt-6 text-[15px] leading-relaxed text-[#2A3446]" dangerouslySetInnerHTML={{ __html: renderRich(cap.contenido) }} />}
    <ResourceList recursos={cap.recursos} testid="cap-module-res" />
    {cap.subsecciones?.length > 0 && (
      <div className="mt-6 grid sm:grid-cols-2 gap-3 items-start">
        {cap.subsecciones.map((s, i) => <Sub key={i} s={s} i={i} />)}
      </div>
    )}
  </div>
);
